import { render, staticRenderFns } from "./CarePairingViewTherapist.vue?vue&type=template&id=103697b3&scoped=true&"
import script from "./CarePairingViewTherapist.vue?vue&type=script&lang=js&"
export * from "./CarePairingViewTherapist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "103697b3",
  null
  
)

export default component.exports